import type { ReactNode, SyntheticEvent } from 'react';
import { createPortal } from 'react-dom';

const stop = (event: SyntheticEvent) => event.stopPropagation();

// Portals escape CSS stacking contexts, but React events still bubble through
// the owning message. Keep viewer gestures out of message menus/long presses.
export function ViewerPortal({ children }: { children: ReactNode }) {
  return createPortal(<div style={{ display: 'contents' }}
    onClick={stop} onDoubleClick={stop} onContextMenu={stop}
    onPointerDown={stop} onPointerUp={stop} onPointerMove={stop}
    onPointerCancel={stop} onMouseDown={stop} onMouseUp={stop}>
    {children}
  </div>, document.body);
}
